<template>
  <div v-el:c :class="{'value':true , 'sort-handle': true}"
       contentEditable="true"
       :placeholder="placeholder"
       @paste="handlePaste"
       @keydown="handleKeyDown"
       @focus='handleFocus'
       @blur='handleBlur'
       @click='handleClick'
       ></div>
       <!-- <b v-if="false" style="float: right">{{info|json}}</b> -->
</template>

<script>
import _ from 'lodash'
// import {nl2br} from 'src/utils/functions'

export default {

  name: 'input-box',

  props: {
    text: String,
    preventKeys: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: () => ''
    },
    isFinished: {
      type: Boolean,
      default: () => false
    },
    itemId: Number,
    index: Number
  },

  data() {
    return {
      focused: false,
      _text: '',
      _lastText: '',
      isEdit: false,
      info: {}
    }
  },

  methods: {
    handlePaste(evt) {
      evt.preventDefault()
      let data = evt.clipboardData.getData('text/plain')
      let selection = window.getSelection()
      let range = selection.getRangeAt(0)
      range.deleteContents()
      let fragment = range.createContextualFragment('')
      fragment.textContent = data
      let replacementEnd = fragment.lastChild
      range.insertNode(fragment)
      // Set cursor at the end of the replaced content, just like browsers do.
      range.setStartAfter(replacementEnd)
      range.collapse(true)
      selection.removeAllRanges()
      selection.addRange(range)

      // this.dispatch()
    },

    handleKeyDown(evt) {
      let el = this.$els.c
      if (evt.keyCode == 13) {
        this.dispatch(false)
        this.focused = false
        this.$els.c.innerHTML = this.getDisplayValue()
        window.getSelection().removeAllRanges()
      }
      if (evt.keyCode == 8) {
        this.info = {
          html: el.innerHTML,
          length: el.innerHTML.length,
          isBr: el.innerHTML == '<br>'
        }
        if (el.innerHTML == ''|| el.innerHTML == '<br>') {

          this.dispatch(false)
        }
      }
      let forbiddenKeys = [
        66, // bold
        73  // italic
      ]
      //@todo 测试mac
      if ((evt.ctrlKey || evt.metaKey) && forbiddenKeys.indexOf(evt.keyCode)>-1) {
        evt.preventDefault()
        evt.stopPropagation()
      }
    },

    handleKeyPress(evt) {
      // this.dispatch()
    },

    handleFocus() {
      this.focused = true
      this.$els.c.innerHTML = this.getDisplayValue()
    },

    handleBlur() {
      this.dispatch(true)
      this.focused = false
      this.$els.c.innerHTML = this.getDisplayValue()
      window.getSelection().removeAllRanges()
    },

    handleClick() {
      // this.isEdit = true
      // setTimeout(function() {
      //   this.$els.c.focus()
      //   this.setEndOfContenteditable(this.$el)
      // }.bind(this),1)
    },

    setEndOfContenteditable(contentEditableElement) {
      var range,selection
      if (document.createRange) { //Firefox, Chrome, Opera, Safari, IE 9+
        range = document.createRange()//Create a range (a range is a like the selection but invisible)
        range.selectNodeContents(contentEditableElement)//Select the entire contents of the element with the range
        range.collapse(false)//collapse the range to the end point. false means collapse to end rather than the start
        selection = window.getSelection()//get the selection object (allows you to change selection)
        selection.removeAllRanges()//remove any selections already made
        selection.addRange(range)//make the range you have just created the visible selection
      } else if (document.selection) { //IE 8 and lower
        range = document.body.createTextRange()//Create a range (a range is a like the selection but invisible)
        range.moveToElementText(contentEditableElement)//Select the entire contents of the element with the range
        range.collapse(false)//collapse the range to the end point. false means collapse to end rather than the start
        range.select()//Select the range (make it the visible selection
      }
    },

    dispatch(isBlur) {
      this._text = this.$els.c.innerText.replace(/[\n\r\t]/g, '')
      this.$dispatch('input-box-change', this._text, isBlur)

      // if (this.isCreate) {
      //   this.restoreValue()
      // }
      // if (!this._dispatch) {
      //   this._dispatch = this.debounceDispatch()
      // }
      // this._dispatch(this._text)
    },

    getDisplayValue() {
      let escapeText = _.escape(this._text)
      // escapeText = nl2br(escapeText)
      escapeText = escapeText.replace(/[\n\r\t]/g, '')
      let ret = escapeText
      if (!this.focused) {
        ret = escapeText
      }
      return ret
    },

    // 不能在插值里直接设置值，因为contenteditable里是dom，直接使用插值会有意想不到的情况发生
    updateDisplayValue() {
      let value = this.getDisplayValue()
      // console.log('updateValue', value)
      if (!this.focused) {
        this.$els.c.innerHTML = value
      }
    },

    debounceDispatch() {
      return _.debounce((text) => {
        this.$dispatch('input-box-change', text)
      }, 500)
    },

    restoreValue() {
      this._text = this._lastText
      this.updateDisplayValue()
    }
  },

  watch: {
    text: function(newValue, oldValue) {
      this._text = newValue
      this._lastText = newValue
      this.updateDisplayValue()
    }
  },

  ready() {
    // console.log('input box ready', this.text)
    this._text = this.text
    this._lastText = this.text
    this.updateDisplayValue()
  },

  events: {
    'input-focus': function(_index) {
      if (this.index == _index) {
        setTimeout(function() {
          this.$el.focus()
          this.setEndOfContenteditable(this.$el)
        }.bind(this), 1)
      }
    }
  },

  beforeDestroy() {
    // console.log('input-box destroy', this.text)
  }
}
</script>


/** WEBPACK FOOTER **
 ** input-box.vue?2f6d0069
 **/